import { ParametroPaginacionGenerico } from 'src/app/util/ParametroPaginacionGenerico';

export class FiltroCoCotizacion {

    numerodoc: string;
    fechadoc: Date;
    fechavenc: Date;
    estado: string;
    clientenum: number;
    nombreCliente: string;
    usuarioActualCompania: string;
    idVendedor: number;

    constructor() {
        this.paginacion = new ParametroPaginacionGenerico();
        this.paginacion.atributoOrdenar = 'NumeroDocumento';
        this.paginacion.direccionOrdenAtributo = 1;
    }

    paginacion: ParametroPaginacionGenerico;
}
